import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const Booking = loadable(() => import(/* webpackChunkName: "Booking" */ './Booking'), {
  fallback: <LoadableFallback visible />,
});

const asyncBooking = ({ route }) => (
  <Booking route={route} />
);

asyncBooking.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncBooking;
